import type { ItineraryInfoMiddlewareRequest, ItineraryInfoMiddlewareResponse } from '../types/itinerary.types';

function resolveBaseUrl(): string {
    return (
        import.meta.env.VITE_ITINERARY_INFO_SERVICE_URL ??
        process.env.VITE_ITINERARY_INFO_SERVICE_URL ??
        'http://localhost:7071/api/itinerary-info'
    );
}

function buildItineraryInfoMiddlewareUrl(request: ItineraryInfoMiddlewareRequest): URL {
    const url = new URL(resolveBaseUrl());

    Object.entries(request).forEach(([key, value]) => {
        if (typeof value === 'string' && value.trim().length > 0) {
            url.searchParams.set(key, value);
        }
    });

    return url;
}

/**
 * Requests itinerary info content from the middleware using validated query parameters.
 * @param request - Query parameters forwarded to the itinerary info middleware endpoint.
 * @returns Middleware response payload for itinerary info content.
 */
export async function fetchItineraryInfoContent(
    request: ItineraryInfoMiddlewareRequest
): Promise<ItineraryInfoMiddlewareResponse> {
    const url = buildItineraryInfoMiddlewareUrl(request);
    const response = await fetch(url.toString());

    if (!response.ok) {
        throw new Error(`Failed to fetch itinerary-info content: ${response}`);
    }

    return (await response.json()) as ItineraryInfoMiddlewareResponse;
}
